import { render, staticRenderFns } from "./VersionConfigurator.vue?vue&type=template&id=34abce2b&scoped=true"
import script from "./VersionConfigurator.vue?vue&type=script&lang=js"
export * from "./VersionConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34abce2b",
  null
  
)

export default component.exports